export default "__VITE_ASSET__3a5f9c40__"